/**
 * A primeira mensagem de validação que o Laravel devolveu, a `message` de um
 * erro sem `errors` (como o 403 "Seu acesso não inclui esta ação."), ou a
 * genérica.
 */
export function erroDaApi(erro: unknown, generica: string): string {
  const resposta = (erro as { response?: { data?: { errors?: Record<string, string[]>; message?: string } } } | null)
    ?.response?.data;

  return (resposta?.errors && Object.values(resposta.errors)[0]?.[0]) || resposta?.message || generica;
}
